<template>
    <div>
        <div class="navigation">
            <input type="checkbox" class="navigation__checkbox" id="navi-toggle">
            <label ref="navigation__button" for="navi-toggle" class="navigation__button">
                <span class="navigation__icon">&nbsp;</span>
            </label>
            <div class="navigation__background">&nbsp;</div>
            <nav class="navigation__nav">
                <div id="nav" class="navigation__item" @click="closeNav()">
                    <router-link to="/" class="navigation__link">Home</router-link>
                    <router-link to="/summarize" class="navigation__link">Summarize</router-link>
                    <router-link to="/about" class="navigation__link">About</router-link>
                </div>
                <ul class="navigation__list" v-if="filterIsVisible">
                  <li class="navigation__item"><a href="#" @click="broadcastEvent(2022)"
                                                  class="navigation__link"><span>Year</span>2022</a></li>
                  <li class="navigation__item"><a href="#" @click="broadcastEvent(2021)"
                                                  class="navigation__link"><span>Year</span>2021</a></li>
                    <li class="navigation__item"><a href="#" @click="broadcastEvent(2020)"
                                                    class="navigation__link"><span>Year</span>2020</a></li>
                    <li class="navigation__item"><a href="#" @click="broadcastEvent(2019)"
                                                    class="navigation__link"><span>Year</span>2019</a></li>
                    <li class="navigation__item"><a href="#" @click="broadcastEvent(2018)"
                                                    class="navigation__link"><span>Year</span>2018</a></li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
        // name: "NavigationMenu",
        component: {
        },
        data() {
            return {
                filterIsVisible: true,
            }
        },

        created() {
            this.$eventHub.$on('filter-data-visible', this.updateFilterDataVisibility)
        },
        methods: {
            updateFilterDataVisibility(data) {
               this.filterIsVisible = data;
            },
            closeNav() {
                setTimeout(() => {

                    this.$refs.navigation__button.click();

                }, 10)
            },
            broadcastEvent(data) {
                setTimeout(() => {

                    this.$refs.navigation__button.click();
                }, 10);
                setTimeout(() => {
                    this.$eventHub.$emit('filter-data', data)
                }, 500)
            }
        }
    }
</script>

<style scoped>

</style>
